import * as React from "react";
export const IconArrowLeftGray = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={props?.size || 32}
		height={props?.size || 32}
		fill="none"
		className="ic-arrow-left-gray"
		{...props}
	>
		<path
			fill={props?.color || "#A8A8A8"}
			d="M8.5 16.686c0-.491.187-.983.562-1.358L20.856 3.535a1.92 1.92 0 1 1 2.716 2.716L13.137 16.686l10.435 10.435a1.92 1.92 0 0 1-2.717 2.716L9.062 18.044a1.915 1.915 0 0 1-.562-1.358Z"
		/>
	</svg>
);
